import { createContext, useContext, useState } from "react";
import axiosInstance from "../../../../../../api/axiosInstance";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useHistory } from "react-router-dom";

interface IState {
    state: {
        url: string;
        nip: number;
        nama: string;
        jabatan: string;
        pangkat: string;
        golongan: string;
        jenisUser: number;
        reason: string;
        judulPengetahuan: string;
        is_approved: boolean | null;
        reason_reject: string;
        isLoadingDetail: boolean;
        isLoadingFetchData: boolean;
        isLoadingAction: boolean;
        listData: [];
        page: number;
        perPage: number;
        jumlahData: number;
    };
    dispatch: {
        setPengetahuanPendaftarDetail: Function;
        getDetailPengetahuanPendaftar: Function;
        handleApprove: Function;
        handleReject: Function;
    };
}

const initialState: IState = {
    state: {
        url: 'pengetahuan/',
        nip: 0,
        nama: '',
        jabatan: '',
        pangkat: '',
        golongan: '',
        jenisUser: 0,
        reason: '',
        judulPengetahuan: '',
        is_approved: null,
        reason_reject: '',
        isLoadingDetail: false,
        isLoadingFetchData: false,
        isLoadingAction: false,
        listData: [],
        page: 1,
        perPage: 10,
        jumlahData: 0,
    },
    dispatch: {
        setPengetahuanPendaftarDetail: () => { },
        getDetailPengetahuanPendaftar: () => { },
        handleApprove: () => { },
        handleReject: () => { },
    },
};

const Context = createContext<IState>(initialState);
const { Provider: ManajemenPengetahuanPendaftarProvider } = Context;

const Provider: React.FC = ({ children }) => {
    const [state, setState] = useState<IState>(initialState);
    const { url, page, perPage } = state.state;
    const history = useHistory();


    const {
        reason,
    } = state.state;


    const setPengetahuanPendaftarDetail = (
        key: keyof IState['state'],
        value: any
    ) => {
        setState((prevState) => ({
            ...prevState,
            state: {
                ...prevState.state,
                [key]: value,
            },
        }));
    };

    const getDetailPengetahuanPendaftar = async (id: number, pengetahuan_id: number) => {
        setPengetahuanPendaftarDetail('isLoadingDetail', true);

        try {
            const response = await axiosInstance.get(`${url}${pengetahuan_id}/approvals/${id}`);

            if (response.status === 200) {
                setPengetahuanPendaftarDetail('nip', response.data.data.user.nip);
                setPengetahuanPendaftarDetail('nama', response.data.data.user.name);
                setPengetahuanPendaftarDetail('jabatan', response.data.data.user.m_peserta.tampil_jabatan);
                setPengetahuanPendaftarDetail('jenisUser', response.data.data.user.jenis_user);
                if (response.data.data.user.jenis_user === 1) {
                    setPengetahuanPendaftarDetail('pangkat', response.data.data.user.m_peserta.pangkat);
                    setPengetahuanPendaftarDetail('golongan', response.data.data.user.m_peserta.gol_ruang);
                }
                if(response.data.data.is_approved === false) {
                    setPengetahuanPendaftarDetail('is_approved', response.data.data.is_approved);
                    setPengetahuanPendaftarDetail('reason_reject', response.data.data.reason_reject);
                }
                if (response.data.data.user_id) {
                    await fetchData(response.data.data.user_id, pengetahuan_id);
                }
            }

            const pengetahuanResponse = await axiosInstance.get(
                `management_content/pengetahuan/${pengetahuan_id}`
            );

            if (pengetahuanResponse.status === 200) {
                setPengetahuanPendaftarDetail('judulPengetahuan', pengetahuanResponse.data.data.title);
            }

        } catch (error) {
            throw error;
        } finally {
            setPengetahuanPendaftarDetail('isLoadingDetail', false);
        }
    };

    const fetchData = async (user_id: number, pengetahuan_id: number) => {
        setPengetahuanPendaftarDetail('isLoadingFetchData', true);

        try {
            const response = await axiosInstance.get(`${url}${pengetahuan_id}/approvals/${user_id}/pelatihan`, {
                params: {
                    page,
                    per_page: perPage,
                },
            });

            setPengetahuanPendaftarDetail('listData', response.data.data);
            setPengetahuanPendaftarDetail('jumlahData', response.data.total);
        } catch (error) {
            const status = error?.response?.status;
            if (status === 400) {
                setPengetahuanPendaftarDetail('listData', []);
                setPengetahuanPendaftarDetail('jumlahData', 0);
            }
        } finally {
            setPengetahuanPendaftarDetail('isLoadingFetchData', false);
        }
    };

    const handleApprove = async (pengetahuan_id: number, id: number, onClose?: () => void) => {
        setPengetahuanPendaftarDetail('isLoadingAction', true);

        try {
            const response = await axiosInstance.put(`${url}${pengetahuan_id}/approvals/${id}/approve`);

            if (response.status === 200) {
                toast.success(response.data.message, {
                    style: {
                        boxShadow: '0px 1px 6px #019166',
                    },
                });
                setTimeout(() => {
                    history.replace(`/admin/manajemen_pengetahuan/${pengetahuan_id}`);
                }, 1000);
            } else {
                toast.error('Terjadi kesalahan saat menyimpan data', {
                    style: {
                        boxShadow: '0px 1px 6px #F86E70',
                    },
                });
            }
        } catch (error) {
            toast.error(error.response?.data?.message || 'Terjadi kesalahan saat menyimpan data', {
                style: {
                    boxShadow: '0px 1px 6px #F86E70',
                },
            });
        } finally {
            setPengetahuanPendaftarDetail('isLoadingAction', false);
            onClose && onClose();
        }
    };

    const handleReject = async (pengetahuan_id: number, id: number, handleClose?: () => void) => {
        setPengetahuanPendaftarDetail('isLoadingAction', true);
        try {
            const response = await axiosInstance.put(`${url}${pengetahuan_id}/approvals/${id}/reject`,
                { reason_reject: reason }
            );

            if (response.status === 200) {
                toast.success(response.data.message, {
                    style: {
                        boxShadow: '0px 1px 6px #019166',
                    },
                });
                setTimeout(() => {
                    history.replace(`/admin/manajemen_pengetahuan/${pengetahuan_id}`);
                }, 1000);
            } else {
                toast.error('Terjadi kesalahan saat menyimpan data', {
                    style: {
                        boxShadow: '0px 1px 6px #F86E70',
                    },
                });
            }
        } catch (error) {
            toast.error(error.response?.data?.message ||
                'Terjadi kesalahan saat menyimpan data', {
                style: {
                    boxShadow: '0px 1px 6px #F86E70',
                },
            });
        } finally {
            setPengetahuanPendaftarDetail('isLoadingAction', false);
            handleClose && handleClose();
        }
    };

    return (
        <ManajemenPengetahuanPendaftarProvider
            value={{
                state: state.state,
                dispatch: {
                    setPengetahuanPendaftarDetail,
                    getDetailPengetahuanPendaftar,
                    handleApprove,
                    handleReject,
                },
            }}
        >
            {children}
        </ManajemenPengetahuanPendaftarProvider>
    );
};

export const useManajemenPengetahuanPendaftarDetailContext = () =>
    useContext(Context);

const ManajemenPengetahuanPendaftarDetailController = {
    useManajemenPengetahuanPendaftarDetailContext,
    Provider,
};

export default ManajemenPengetahuanPendaftarDetailController;